import { Badge, ListItem, Typography } from "@mui/material";

import { useAnnounceKit } from "../../../utils/announcekit/announcekitHooks";

export const WhatsNewButtonWrapper = () => {
  const { openAnnounceKit, unread } = useAnnounceKit();

  return (
    <ListItem sx={{ color: "navigation.subItemColor" }} dense disableGutters data-cy="item-5" onClick={openAnnounceKit}>
      <Badge
        variant="dot"
        sx={{
          "& .MuiBadge-dot": {
            backgroundColor: "#CAD2FF",
          },
        }}
        invisible={!unread}
      >
        <Typography id="whatsNew-button" variant="body2">
          What's new
        </Typography>
      </Badge>
    </ListItem>
  );
};
